import type { BrandJson } from "@coras-io/brand-tokens";
import {
  DEFAULT_CURRENCIES,
  DEFAULT_LOCALES,
  type SiteConfig,
} from "../../src/types";
import brandConfig from "./brand.json";

export const brand = brandConfig as BrandJson;

export const site: SiteConfig = {
  distributorId: "ec566eb7-abfd-494e-88ac-5d3ba4bc8788",
  title: "Sun Country Airlines",
  description: "Book tickets to West End Shows, Concerts and more",
  locale: "en-US",
  currency: "USD",
  locales: DEFAULT_LOCALES,
  currencies: DEFAULT_CURRENCIES,
  favicons: [
    "apple-touch-icon-180x180.png",
    "favicon-16x16.png",
    "favicon-32x32.png",
    "favicon.ico",
  ],
  logo: "/assets/images/logo.svg",
  domain: "suncountry.coras.io",
  detectLocale: false,
  detectCurrency: false,
};
